// src/Pages/PaymentSuccess.js
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { db } from "../firebase";
import {
  collection,
  serverTimestamp,
  getDoc,
  doc,
  setDoc,
} from "firebase/firestore";
import { useAuth } from "../auth/AuthContext";
import { useCart } from "../cart/CartContext";

export default function PaymentSuccess() {
  const { currentUser } = useAuth();
  const { items, subtotal, currency, clearCart } = useCart();

  useEffect(() => {
    const saveOrder = async () => {
      // אם אין משתמש מחובר או שהעגלה ריקה – לא יוצרים הזמנה
      if (!currentUser || !items || items.length === 0) return;

      try {
        // 🔥 הבאת פרטי משלוח של המשתמש (shippingInfo)
        const userRef = doc(db, "users", currentUser.uid);
        const userSnap = await getDoc(userRef);
        const userData = userSnap.exists() ? userSnap.data() : {};

        const shippingInfo = userData.shippingInfo || null;

        // 🔥 יצירת מסמך הזמנה עם ID אוטומטי של Firestore
        const orderRef = doc(collection(db, "orders"));

        await setDoc(orderRef, {
          orderId: "#" + orderRef.id.slice(-6),
          userId: currentUser.uid,
          userEmail: currentUser.email || "",
          items: items,
          total: subtotal,
          currency: currency || "USD",
          createdAt: serverTimestamp(),

          // ⭐ מוסיף shipping info להזמנה
          shippingInfo: shippingInfo,

          // ⭐ סטטוס התחלתי של הזמנה
          status: "processing",
        });

        // מנקים את העגלה רק אחרי שההזמנה נשמרה בהצלחה
        clearCart();
      } catch (err) {
        console.error("Failed to save order:", err);
      }
    };

    saveOrder();
  }, [currentUser, items, subtotal, currency, clearCart]);

  return (
    <main
      style={{
        minHeight: "70vh",
        padding: "120px 16px 40px",
        background: "linear-gradient(180deg, #07051a 0%, #05030d 100%)",
        color: "#f5f5f5",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <section
        style={{
          width: "100%",
          maxWidth: 640,
          background: "rgba(8, 8, 20, 0.85)",
          borderRadius: 16,
          padding: "32px 24px 36px",
          boxShadow: "0 14px 40px rgba(0, 0, 0, 0.65)",
          border: "1px solid rgba(255, 255, 255, 0.04)",
          textAlign: "center",
        }}
      >
        <div
          style={{
            width: 64,
            height: 64,
            borderRadius: "50%",
            margin: "0 auto 18px",
            background:
              "radial-gradient(circle at 30% 20%, #5cf5a5 0, #1ea63c 45%, #0a4f20 85%)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow:
              "0 0 15px rgba(130, 255, 180, 0.4), 0 0 60px rgba(56, 142, 60, 0.6)",
          }}
        >
          <span style={{ fontSize: 34 }}>✔</span>
        </div>

        <h1
          style={{
            fontSize: "1.9rem",
            marginBottom: 10,
            letterSpacing: "0.04em",
          }}
        >
          Thank you for your order!
        </h1>

        <p
          style={{
            margin: "0 auto 22px",
            maxWidth: 440,
            fontSize: "0.98rem",
            lineHeight: 1.6,
            color: "#d4d4e0",
          }}
        >
          Your payment was processed successfully. <br />
          Your order details will appear in your account shortly.
        </p>

        <div
          style={{
            marginTop: 24,
            padding: "14px 16px",
            borderRadius: 12,
            background: "rgba(22, 163, 74, 0.07)",
            border: "1px solid rgba(34, 197, 94, 0.25)",
            fontSize: "0.9rem",
            color: "#c8f3d3",
          }}
        >
          You can always review your orders and track updates in{" "}
          <strong>My Orders</strong>.
        </div>

        <Link
          to="/my-orders"
          style={{
            display: "inline-block",
            marginTop: 30,
            padding: "12px 24px",
            borderRadius: 8,
            background: "#2e7d32",
            color: "white",
            textDecoration: "none",
            fontWeight: 600,
          }}
        >
          View My Orders
        </Link>
      </section>
    </main>
  );
}